<div class="main">
    <div class="dx-field-title" translate>fileTransfersArchivedFilesAccesses.pageTitle</div>
    <div class="dx-field selector">
        <div class="dx-field-label">{{ this.currentEnvironmentName }}&nbsp;/</div>
        <div class="dx-field-value">
            <app-file-transfer-picker [fileTransfers]="fileTransfers" (selectedItemChange)="filterChanged($event)"></app-file-transfer-picker>
        </div>
    </div>
    <br />
    <dx-data-grid #accessesGrid
                  [dataSource]="dataSource"
                  keyExpr="id"
                  [columnAutoWidth]="true"
                  [wordWrapEnabled]="true"
                  height="calc(100vh - 215px)"
                  hoverStateEnabled="true"
                  [errorRowEnabled]="false"
                  (onToolbarPreparing)="onToolbarPreparing($event)"
                  (onContextMenuPreparing)="onContextMenuPreparing($event)">
        <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
        <dxo-header-filter></dxo-header-filter>
        <dxo-paging enabled="false"></dxo-paging>
        <dxo-summary>
            <dxi-total-item column="properties.displayName" [displayFormat]="'fileTransfersArchivedFilesAccesses.lblAccessCount' | translate" summaryType="count"></dxi-total-item>
        </dxo-summary>
        <!-- DataGrid columns -->
        <dxi-column [width]="100" dataField="user.photo" caption="" [allowSorting]="false" cellTemplate="pictureCellTemplate"></dxi-column>
        <dxi-column dataField="properties.displayName" [caption]="'_commons.name' | translate"></dxi-column>
        <dxi-column dataField="name" [caption]="'_commons.email' | translate" cellTemplate="mailCellTemplate"></dxi-column>

        <!-- Custom cell templates -->
        <div *dxTemplate="let cell of 'mailCellTemplate'">
            <a href="mailto:{{cell.data.name}}">{{cell.data.name}}</a>
        </div>
        <div *dxTemplate="let cell of 'pictureCellTemplate'">
            <img class="img" [src]="cell.data.photo" alt="photo" width="48" height="48" />
        </div>
    </dx-data-grid>
</div>

<!-- Create popup -->
<dx-popup [title]="'fileTransfersArchivedFilesAccesses.popupCreateTitle' | translate" [(visible)]="isPopupVisible"
    [height]="240">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view direction="vertical" *ngIf="isPopupVisible">
            <dx-validation-group #accessValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>_commons.employee<span class="dx-field-item-required-mark">
                            *</span></div>
                    <div class="dx-field-value">
                        <app-employee-picker [(selectedItem)]="newEmployeeAccess" [isRequired]="true"></app-employee-picker>
                    </div>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="save" [text]="'_commons.add' | translate" (onClick)="createAccess()"></dx-button>
                    <dx-button class="delete" [text]="'_commons.cancel' | translate" (onClick)="this.isPopupVisible = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
